<template>
	<ViewWrapper :carregando="carregando">
		<template #titulo>
			Editar Perfil
		</template>
		<template #botaoHeader>
			<v-btn color="primary" :loading="carregando" @click="salvarPerfil">
				SALVAR
			</v-btn>
		</template>

		<v-container fluid v-if="dados">
			<v-row justify="center">
				<v-col cols="12" lg="7" class="px-0">
					<v-row class="mx-0">
						<v-col cols="12">
							<div class="mb-2 mr-6">Nome</div>
							<v-text-field v-model="dados.nome" disabled/>
						</v-col>
						<v-col cols="12">
							<div class="mb-2 mr-6">CPF</div>
							<v-mask-input v-model="dados.cpf" mask="###.###.###-##" prepend-inner-icon="mdi-card-account-details-outline" disabled/>
						</v-col>
						<v-col cols="12">
							<div class="mb-2 mr-6">E-mail</div>
							<v-text-field v-model="dados.email" :rules="[campoEmail]" persistent-hint hint="O email acima será utilizado apenas para fins de notificações relativas ao progresso de suas solicitações."/>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="12" sm="8" lg="5" />
			</v-row>
		</v-container>
	</ViewWrapper>
</template>

<script setup>
import { atualizarPerfilUsuario } from "@/services/UsuarioService.js";
import { ErroAlert, SucessoAlert } from "@/utils/AlertUtils.js";
import { useStore } from "vuex";
import ViewWrapper from "@/components/commons/wrapper/ViewWrapper.vue";
import { onMounted, ref } from "vue";

const store = useStore();

const campoEmail = (val) => {
	const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if (!regex.test(val)) {
		return "Preencha um E-mail válido!";
	}
	return true;
};

const carregando = ref(false);
const dados = ref({
	nome: "",
	cpf: "",
	email: "",
})
const usuarioLogado = ref(store.getters["usuario/getUsuarioLogado"]);

onMounted(() => {
	if (usuarioLogado.value && usuarioLogado.value.id) {
		dados.value.nome = usuarioLogado.value.nome;
		dados.value.cpf = usuarioLogado.value.cpf;
		dados.value.email = usuarioLogado.value.email;
	}
});


async function salvarPerfil(){
	carregando.value = true;
	await atualizarPerfilUsuario(usuarioLogado.value.id || 0, {
		...usuarioLogado.value,
		...dados.value,
	})
		.then((response) => {
			store.commit("usuario/setUsuarioLogado", response.data);
			SucessoAlert({ mensagem: "Perfil salvo com sucesso!" });
		})
		.catch((error) => {
			ErroAlert({ mensagem: error.response.data.mensagem, error });
			console.error(e);
		})
		.finally(() => {
			carregando.value = false;
		});
};
</script>
